import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { loadTariffs } from './redux/actions';
import { TariffChooserPlaceholder } from './chooser';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { useNavigate } from 'react-router';
import { TariffStepper } from './tariff-stepper';
import { CompareCards } from 'shared/components/compare-card';
import { isUpgrade } from 'console/billing/account-tariff/utils';
import { TariffCard } from 'console/billing/account-tariff/card';
import { ColumnBox } from 'shared/components/containers';
export function TariffChooserContent() {
    const navigate = useNavigate();
    const onLoadTariff = useAction(loadTariffs);
    const { tariffs_loading, tariffs } = useAppSelector((state) => state.tariffs);
    useEffect(() => {
        if (tariffs == null && !tariffs_loading) {
            onLoadTariff();
        }
    }, [tariffs, tariffs_loading]);
    const currentTariff = useAppSelector((state) => state.billing.state.data.tariff.current);
    const onChooseTariff = useCallback((tariff) => {
        navigate(tariff, { state: { targetTariff: tariff } });
    }, []);
    const component = useCallback((description) => (_jsx(TariffCard, { description: description, isCurrent: description.id == currentTariff, isUpgrade: isUpgrade(currentTariff, description.id, tariffs), onChoose: () => onChooseTariff(description.id) })), [tariffs, currentTariff, onChooseTariff]);
    return (_jsxs(ErrorBoundary, { children: [_jsx(ColumnBox, { justifyContent: "space-between", children: tariffs != null ? (_jsx(CompareCards, { data: tariffs, component: component })) : (_jsx(TariffChooserPlaceholder, {})) }), _jsx(Box, { pb: 2, children: _jsx(TariffStepper, { step_id: 0 }) })] }));
}
